import Vue from 'vue'
import rHeader from "./components/global/rHeader";
import rBranchList from "./components/branches/rBranchList";
import rFooter from "./components/global/rFooter";
import rLanguagePicker from "./components/global/rLanguagePicker";
import rTextBox from "./components/global/rTextBox";
import rServicesList from "./components/branch/rServicesList";
import rDateLoader from "./components/branch/rDateLoader";
import rTimeLoader from "./components/branch/rTimeLoader";
import rLoadingOverlay from "./components/global/rLoadingOverlay"
import rMessageOverlay from "./components/global/rMessageOverlay"
import rTicketOverlay from "./components/global/rTicketOverlay"
import { OrbitSpinner } from 'epic-spinners';
import offline from 'v-offline';

Vue.component("rHeader", rHeader);
Vue.component("offline", offline);
Vue.component("rBranchList", rBranchList);
Vue.component("rFooter", rFooter);
Vue.component("rLanguagePicker", rLanguagePicker);
Vue.component("rServicesList", rServicesList);
Vue.component("rTextBox", rTextBox);
Vue.component("rDateLoader", rDateLoader);
Vue.component("rTimeLoader", rTimeLoader);
Vue.component("rLoadingOverlay", rLoadingOverlay);
Vue.component("rMessageOverlay", rMessageOverlay);
Vue.component("rTicketOverlay", rTicketOverlay);
Vue.component("OrbitSpinner", OrbitSpinner);